import { IndeterminateProgressCircle } from '@sunwebgroup/uds-ui/IndeterminateProgressCircle'
import { cn } from '@sunwebgroup/uds-ui/utils'
import styles from './UserReviewLoading.module.css'

export function UserReviewLoading({ className }: { className?: string }) {
  return (
    <div className={cn(styles.cardSkeleton, className)}>
      <div>
        <IndeterminateProgressCircle />
      </div>
    </div>
  )
}
